import AcceptAnOrder from './AcceptAnOrder'
import CompleteAnOrder from './CompleteAnOrder'
import GetSupport from './GetSupport'
import StartADash from './StartADash'

export type SlideProps = {
  index?: number
  isFooterHidden?: boolean
  renderFooterContent?: React.ReactNode
}

export { AcceptAnOrder, CompleteAnOrder, GetSupport, StartADash }
